/*
 * hide-decimals-v2.js
 * Removes ".00" from prices (₹275.00 -> ₹275) even when the cart is rendered
 * by a third-party app: works in the normal DOM, open AND closed shadow roots,
 * and same-origin iframes, and keeps working when the app re-renders.
 *
 * PLACE IN <head> (as early as possible, before the cart app loads) so that
 * closed shadow roots can be captured.
 */
(function () {
  'use strict';

  if (window.__hideZeroDecimalsV2) return;
  window.__hideZeroDecimalsV2 = true;

  // Digit(s) followed by ".00" and not followed by another digit
  var ZERO_DECIMALS = /(\d)\.00(?!\d)/g;
  // Only touch text that looks like a price: a currency symbol/code near the number
  var LOOKS_LIKE_PRICE = /(₹|Rs\.?|INR)\s*[\d,]+\.00(?!\d)/i;

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, CODE: 1, PRE: 1 };

  var observed = new WeakSet();   // roots we already observe
  var roots = [];                 // all roots we know about (document, shadow roots, iframe docs)

  /* ---------- text cleaning ---------- */

  function cleanText(root) {
    var doc = root.ownerDocument || root;
    var walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (p && p.nodeType === 1 && SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v && v.indexOf('.00') !== -1) {
        // price in one node: "₹275.00"
        // or number-only node inside a price element (e.g. <span>275.00</span> next to a "₹" span)
        var inPriceEl = isInsidePriceElement(node);
        if (LOOKS_LIKE_PRICE.test(v) || inPriceEl) {
          var nv = v.replace(ZERO_DECIMALS, '$1');
          if (nv !== v) node.nodeValue = nv; // write only when changed -> no observer loops
        }
      }
    }
  }

  function isInsidePriceElement(textNode) {
    var el = textNode.parentNode;
    var depth = 0;
    while (el && el.nodeType === 1 && depth < 4) {
      var cls = (el.getAttribute && el.getAttribute('class')) || '';
      if (/price|amount|money/i.test(cls)) return true;
      el = el.parentNode;
      depth++;
    }
    return false;
  }

  /* ---------- root discovery ---------- */

  function register(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    roots.push(root);

    cleanText(root);

    try {
      new MutationObserver(schedule).observe(root, {
        childList: true, subtree: true, characterData: true
      });
    } catch (e) {}

    scan(root);
  }

  // find open shadow roots and same-origin iframes below a node
  function scan(root) {
    var all;
    try { all = root.querySelectorAll('*'); } catch (e) { return; }
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.shadowRoot) register(el.shadowRoot);
      if (el.tagName === 'IFRAME') hookIframe(el);
    }
  }

  function hookIframe(iframe) {
    function attach() {
      try {
        var d = iframe.contentDocument;
        if (d && d.body) register(d);
      } catch (e) { /* cross-origin: cannot be reached from JS, nothing to do */ }
    }
    attach();
    iframe.addEventListener('load', attach);
  }

  /* ---------- capture CLOSED shadow roots (must run before the app) ---------- */

  try {
    var nativeAttach = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      var sr = nativeAttach.call(this, init);
      try { register(sr); } catch (e) {}
      return sr;
    };
  } catch (e) {}

  /* ---------- scheduling ---------- */

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      sweep();
    });
  }

  function sweep() {
    for (var i = 0; i < roots.length; i++) {
      cleanText(roots[i]);
      scan(roots[i]); // pick up newly created shadow roots / iframes
    }
  }

  /* ---------- start ---------- */

  function start() {
    register(document);
    // Safety net: some apps re-render in ways that are easy to miss.
    setInterval(sweep, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();